import { render } from "./Assigned_Assets.vue?vue&type=template&id=71312a74"
import script from "./Assigned_Assets.vue?vue&type=script&lang=js"
export * from "./Assigned_Assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__